/*
  Skéina Produktseite: Angebots-Karten "Einzeln oder als Set" tauschen Galerie, Titel, Untertitel,
  Hautprofil und Produktinfos (.skn-pinfo: USP-Icons, Zahlen, Akkordeons) gegen den Inhalt des gewählten Set-Produkts.
  "Einzeln" stellt den Originalzustand wieder her. Warenkorb, Preis und Set-Overlay bleiben bei
  sections/skn-main (SknBuybox); dieses Skript tauscht nur Inhalte.

  Datenquelle: Section Rendering API (/products/<handle>?sections=<template-id>__main).
  Die Template-ID eines Set-Templates kennt Liquid auf dieser Seite nicht. Sie wird beim ersten Abruf aus der
  vollständigen Set-Seite gelernt und pro Vorlage in sessionStorage gemerkt (auch jede besuchte Produktseite
  trägt ihre eigene ein). Ergebnisse werden pro URL im Speicher gehalten.
*/
(() => {
  if (window.SknOfferSwap) return;
  window.SknOfferSwap = true;

  const store = {
    get(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) { /* privat: ohne Merken weiter */ } }
  };
  const tplKey = (tpl) => 'skn-tpl:' + (tpl || '-');
  const prefixOf = (id) => (id && id.lastIndexOf('__') > 0 ? id.slice(0, id.lastIndexOf('__')) : '');
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches || typeof Element.prototype.animate !== 'function';
  const previewId = new URLSearchParams(window.location.search).get('preview_theme_id');
  const pageUrl = (path, params) => {
    const url = new URL(path, window.location.origin);
    if (previewId) url.searchParams.set('preview_theme_id', previewId);
    Object.entries(params || {}).forEach(([k, v]) => url.searchParams.set(k, v));
    return url.toString();
  };
  const sectionKey = (el) => {
    const sec = el && el.closest('[id^="shopify-section-"]');
    return sec ? sec.id.replace('shopify-section-', '') : '';
  };

  /* Teile einer (Set-)Produktseite herauslösen und als Vorlage aufbewahren; jeder Einsatz klont neu */
  const extract = (doc) => {
    const box = doc.querySelector('skn-buybox .skn-box');
    const pick = (sel, root) => {
      const el = (root || doc).querySelector(sel);
      return el ? document.importNode(el, true) : null;
    };
    const data = {
      gallery: pick('skn-gallery'),
      title: box ? pick('.skn-box__title', box) : null,
      subtitle: box ? pick('.skn-box__subtitle', box) : null,
      profile: box ? pick('.skn-sp', box) : null,
      pinfo: box ? pick('.skn-pinfo', box) : null
    };
    return data.gallery || data.title ? data : null;
  };

  const cache = new Map();

  class Swapper {
    constructor(buybox) {
      this.box = buybox;
      this.offers = [...buybox.querySelectorAll('[data-offer]')];
      this.own = this.offers.find((o) => 'own' in o.dataset) || null;
      this.ownPrefix = prefixOf(buybox.dataset.swapSection);
      this.mainKey = (buybox.dataset.swapSection || '').replace(this.ownPrefix + '__', '') || 'main';
      if (this.ownPrefix) store.set(tplKey(buybox.dataset.swapTpl), this.ownPrefix);
      if (!this.own || this.offers.length < 2) return;

      this.current = this.own;
      this.seq = 0;
      this.link = buybox.querySelector('[data-set-link]');
      this.linkA = this.link && this.link.querySelector('a');
      this.linkName = this.link && this.link.querySelector('[data-set-link-name]');
      this.live = buybox.querySelector('[data-swap-live]');

      this.offers.forEach((o) => {
        o.addEventListener('change', () => { if (o.checked) this.select(o, true); });
        const card = o.closest('[data-deal]');
        const warm = () => this.load(o).catch(() => {});
        card?.addEventListener('pointerenter', warm, { once: true });
        card?.addEventListener('touchstart', warm, { once: true, passive: true });
        card?.addEventListener('focusin', warm, { once: true });
      });

      /* Vorab laden, sobald die Karten in Sichtweite kommen: nacheinander, im Leerlauf, nicht bei Datensparmodus */
      const conn = navigator.connection;
      const slow = conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''));
      const deals = buybox.querySelector('[data-deals]');
      /* Erst nach dem ersten Laden (load + 2,5 s), damit der Erstaufruf nicht mit dem Set-Abruf konkurriert.
         Bei Berührung/Hover einer Set-Karte sofort. */
      if (deals) {
        let started = false;
        const go = () => { if (started) return; started = true; this.prefetchAll(); };
        deals.addEventListener('pointerenter', go, { once: true, passive: true });
        deals.addEventListener('touchstart', go, { once: true, passive: true });
        deals.addEventListener('focusin', go, { once: true });
        if (!slow) {
          const later = () => window.setTimeout(() => this.idle(go), 2500);
          if (document.readyState === 'complete') later();
          else window.addEventListener('load', later, { once: true });
        }
      }

      /* Browser stellt nach "Zurück" eine Set-Auswahl wieder her: Inhalte still nachziehen */
      const start = this.offers.find((o) => o.checked);
      if (start && start !== this.own) this.select(start, false);
    }

    idle(fn) {
      if ('requestIdleCallback' in window) window.requestIdleCallback(fn, { timeout: 3000 });
      else window.setTimeout(fn, 600);
    }

    prefetchAll() {
      const queue = this.offers.filter((o) => o !== this.own && !o.disabled);
      const next = () => {
        const o = queue.shift();
        if (!o) return;
        this.idle(() => this.load(o).catch(() => {}).then(next));
      };
      next();
    }

    entry(input) {
      if (input === this.own) return { url: window.location.pathname, tpl: this.box.dataset.swapTpl, prefix: this.ownPrefix };
      return { url: input.dataset.url, tpl: input.dataset.tpl, prefix: store.get(tplKey(input.dataset.tpl)) };
    }

    load(input) {
      const e = this.entry(input);
      if (!e.url) return Promise.reject(new Error('no url'));
      if (cache.has(e.url)) return cache.get(e.url);
      const p = this.fetchParts(e).catch((err) => { cache.delete(e.url); throw err; });
      cache.set(e.url, p);
      return p;
    }

    async fetchParts(e) {
      const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
      if (e.prefix) {
        try {
          const ids = [e.prefix + '__' + this.mainKey];
          const res = await fetch(pageUrl(e.url, { sections: ids.join(',') }), { credentials: 'same-origin' });
          if (res.ok) {
            const json = await res.json();
            if (json[ids[0]]) {
              const data = extract(parse(ids.map((id) => json[id] || '').join('')));
              if (data) return data;
            }
          }
        } catch (err) { /* Vorlage geändert: unten über die ganze Seite */ }
      }
      const res = await fetch(pageUrl(e.url), { credentials: 'same-origin' });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      const doc = parse(await res.text());
      const learned = prefixOf(sectionKey(doc.querySelector('skn-buybox')));
      if (learned && e.tpl !== undefined) store.set(tplKey(e.tpl), learned);
      const data = extract(doc);
      if (!data) throw new Error('no content');
      return data;
    }

    /* Erstes Galeriebild vorladen, damit nach dem Tausch kein leerer Rahmen zu sehen ist (max. 700 ms warten) */
    preload(data) {
      const img = data.gallery && data.gallery.querySelector('.skn-gal__img');
      if (!img) return Promise.resolve();
      return new Promise((resolve) => {
        const pre = new Image();
        const done = () => resolve();
        pre.onload = done;
        pre.onerror = done;
        if (img.getAttribute('sizes')) pre.sizes = img.getAttribute('sizes');
        if (img.getAttribute('srcset')) pre.srcset = img.getAttribute('srcset');
        pre.src = img.getAttribute('src') || '';
        if (pre.complete) resolve();
        window.setTimeout(done, 700);
      });
    }

    targets() {
      return {
        gallery: this.box.querySelector('skn-gallery'),
        title: this.box.querySelector('.skn-box__title'),
        subtitle: this.box.querySelector('.skn-box__subtitle'),
        profile: this.box.querySelector('.skn-box > .skn-sp'),
        pinfo: this.box.querySelector('.skn-box > .skn-pinfo')
      };
    }

    fade(els, from, to, duration, easing) {
      const list = els.filter(Boolean);
      if (reduced() || !list.length) return Promise.resolve();
      return Promise.all(list.map((el) => {
        el.getAnimations?.().forEach((a) => { if (a.id === 'skn-swap') a.cancel(); });
        const a = el.animate([{ opacity: from }, { opacity: to }], { duration, easing: easing || 'ease', fill: 'forwards' });
        a.id = 'skn-swap';
        return a.finished.catch(() => {});
      }));
    }

    clearFade(els) {
      els.filter(Boolean).forEach((el) => el.getAnimations?.().forEach((a) => { if (a.id === 'skn-swap') a.cancel(); }));
    }

    async select(input, fromUser) {
      if (input === this.current) return;
      const token = ++this.seq;
      this.current = input;
      const t = this.targets();
      const els = [t.gallery, t.title, t.subtitle, t.profile, t.pinfo];
      this.box.setAttribute('aria-busy', 'true');
      if (input !== this.own) this.load(this.own).catch(() => {});

      /* Ladezustand: dezent abdunkeln, während geladen wird */
      const dim = this.fade(els, 1, 0.4, 140, 'ease-out');
      let data;
      try {
        data = await this.load(input);
        await this.preload(data);
      } catch (err) {
        if (token !== this.seq) return;
        this.clearFade(els);
        this.box.removeAttribute('aria-busy');
        this.current = null;
        return;
      }
      await dim;
      if (token !== this.seq) return;
      await this.fade(els, 0.4, 0, 90, 'ease-in');
      if (token !== this.seq) return;

      /* Scroll-Position halten: Die angeklickte Karte bleibt exakt an ihrer Bildschirmposition, auch wenn Galerie
         oder Texte darüber durch den Tausch höher oder niedriger werden. Browser-Scroll-Anchoring dafür kurz aus. */
      const anchor = input.closest('[data-deal]') || this.box.querySelector('[data-deals]');
      const top0 = anchor ? anchor.getBoundingClientRect().top : null;
      const root = document.documentElement;
      root.style.overflowAnchor = 'none';
      const fresh = this.apply(data, t);
      this.updateLink(input);
      if (anchor && top0 !== null && anchor.isConnected) {
        const drift = anchor.getBoundingClientRect().top - top0;
        if (Math.abs(drift) > 0.5) window.scrollBy({ top: drift, left: 0, behavior: 'instant' });
      }
      window.clearTimeout(this.anchorTimer);
      this.anchorTimer = window.setTimeout(() => { root.style.overflowAnchor = ''; }, 600);
      this.box.removeAttribute('aria-busy');
      this.fade(fresh, 0, 1, 220, 'cubic-bezier(.23, 1, .32, 1)').then(() => this.clearFade(fresh));

      if (fromUser && this.live) {
        const name = input === this.own ? (this.box.querySelector('.skn-box__title')?.textContent || '').trim() : (input.dataset.name || '');
        this.live.textContent = '';
        window.setTimeout(() => { this.live.textContent = 'Bilder und Beschreibung für ' + name + ' geladen'; }, 350);
      }
    }

    apply(data, t) {
      const fresh = [];

      if (data.gallery && t.gallery) {
        const g = data.gallery.cloneNode(true);
        t.gallery.replaceWith(g);
        fresh.push(g);
      } else fresh.push(t.gallery);

      if (data.title && t.title) {
        t.title.innerHTML = data.title.innerHTML;
        fresh.push(t.title);
      }

      if (data.subtitle) {
        const s = data.subtitle.cloneNode(true);
        if (t.subtitle) t.subtitle.replaceWith(s);
        else (this.link || this.box.querySelector('.skn-price'))?.before(s);
        fresh.push(s);
      } else if (t.subtitle) t.subtitle.remove();

      if (data.profile && t.profile) {
        const p = data.profile.cloneNode(true);
        p.setAttribute('data-ready', '');
        p.classList.remove('skn-sp--anim');
        t.profile.replaceWith(p);
        fresh.push(p);
      } else fresh.push(t.profile);

      /* Produktinfos: ersetzen, sonst vor dem Hautprofil bzw. am Ende der Kaufbox einsetzen. Der neue Inhalt öffnet
         seinen Standard-Punkt (z. B. „Das ist drin“); ein gerade offener Punkt mit gleichem Titel bleibt zusätzlich offen. */
      if (data.pinfo) {
        const n = data.pinfo.cloneNode(true);
        const openTitle = t.pinfo?.querySelector('[data-pacc].is-open .skn-pacc__title')?.textContent.trim();
        if (openTitle && window.SknPacc) {
          const items = [...n.querySelectorAll('[data-pacc]')];
          const hit = items.find((i) => i.querySelector('.skn-pacc__title')?.textContent.trim() === openTitle);
          if (hit) window.SknPacc.set(hit, true);
        }
        n.querySelectorAll('.skn-pacc__panel').forEach((pn) => { pn.style.transition = 'none'; });
        if (t.pinfo) t.pinfo.replaceWith(n);
        else {
          const box = this.box.querySelector('.skn-box');
          const sp = box && box.querySelector(':scope > .skn-sp');
          if (sp) sp.before(n);
          else box?.append(n);
        }
        requestAnimationFrame(() => requestAnimationFrame(() => n.querySelectorAll('.skn-pacc__panel').forEach((pn) => { pn.style.transition = ''; })));
        fresh.push(n);
      } else if (t.pinfo) t.pinfo.remove();

      return fresh;
    }

    updateLink(input) {
      if (!this.link) return;
      const isSet = input !== this.own && input.dataset.url;
      this.link.hidden = !isSet;
      if (!isSet) return;
      if (this.linkA) this.linkA.href = input.dataset.url;
      if (this.linkName) this.linkName.textContent = input.dataset.name || '';
    }
  }

  const init = () => {
    document.querySelectorAll('skn-buybox[data-swap-section]').forEach((b) => {
      if (b.sknSwap) return;
      b.sknSwap = new Swapper(b);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
